import { observer } from 'mobx-react';
import { FC, ReactElement, useCallback, useMemo } from 'react';
import { webhookEditStore } from '../../store';
import { ORDER_STATUS } from '~/constants/order';
import { localeStore } from '~/mobx/localesStore';
import { Checkbox } from '~/view/components/Controls/Checkbox/Checkbox';
import './style.scss';

interface IProps {
  status: ORDER_STATUS;
}

const WebhookEditStatus: FC<IProps> = observer(({ status }: IProps): ReactElement => {
  const isActive = useMemo((): boolean => {
    return webhookEditStore.webhook.statuses.some((_status) => _status === status);
  }, [status, webhookEditStore.webhook.statuses]);

  const selectStatus = useCallback(() => {
    const newStatusesArray: ORDER_STATUS[] = isActive
      ? webhookEditStore.webhook.statuses.filter((_status) => _status !== status)
      : webhookEditStore.webhook.statuses.concat(status);

    webhookEditStore.changeWebhook({ statuses: newStatusesArray });
  }, [status, isActive, webhookEditStore.webhook.statuses]);

  return (
    <li className="webhook-edit-statuses-block-status">
      <Checkbox value={isActive} name={status} label={localeStore.t(status + '_status')} onClick={selectStatus} />
    </li>
  );
});

export default WebhookEditStatus;
